module.exports = __webpack_public_path__ + "icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon.png
// module id = 47
// module chunks = 0